export const notificationsReducer = (state = { dbotNotification: null }, action) => {
  if (action.type === "DBOT_NOTIFICATION") {
    return { ...state, dbotNotification: action.payload };
  }
  return state;
};
